import { validateUsername } from "@/lib/username";

export type LearnerIdentityErrors = { displayName?: string; username?: string };

/** Learner identity = profiles.display_name + profiles.username (both required). */
export function validateLearnerIdentity(input: { displayName: string; username: string }): LearnerIdentityErrors {
  const errors: LearnerIdentityErrors = {};
  const name = (input.displayName ?? "").trim();
  if (!name) errors.displayName = "Display name is required.";
  else if (name.length > 40) errors.displayName = "Display name must be at most 40 characters.";
  const u = validateUsername(input.username);
  if (u.ok === false) errors.username = u.message;
  return errors;
}
